import { render, staticRenderFns } from "./ExhibitCardNormal.vue?vue&type=template&id=38375340"
import script from "./ExhibitCardNormal.vue?vue&type=script&lang=js"
export * from "./ExhibitCardNormal.vue?vue&type=script&lang=js"
import style0 from "./ExhibitCardNormal.vue?vue&type=style&index=0&id=38375340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports